import axiosClient from "../../common/axios/axiosConfig";
import useQuery from "../../utils/useQuery";

export const isPatientStillInQueue = async (
  id: string,
  patientId: string,
) => {
  try {
    const urlSearchParams = useQuery();
    const telemedicineToken = urlSearchParams.get("token") || "";

    const response = await axiosClient.get(`/room/${id}/waiting/${patientId}/exists`, {
      headers: {
        Authorization: `Bearer ${telemedicineToken}`,
      },
    }
    );
    return response.data;
  } catch (err) {
    console.error("Erro ao encontrar paciente na fila de espera:", err);
    return { exists: true };
  }
};
